import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/catalog/id/arrow.svg")